module.exports = __webpack_public_path__ + "static/media/ba.c4db3889.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/ba.svg
// module id = 1430
// module chunks = 0